export const figure13 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 100,
spacingBottom: 45,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'column',
height: '400px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
	 fontFamily: 'Montserrat'
 }
},
title: {
text: null
},
subtitle: {
text: null
},
credits: {
enabled: false
},
legend: {
enabled: false,
}, 
exporting: {
enabled: false
},
colors: ['#ffd653', '#ffd653'],
xAxis: {
categories: [
	     "آسيا الوسطى وجنوب آسيا",
	     "أوقيانوسيا باستثناء أستراليا ونيوزيلندا*",
	     "أفريقيا جنوب الصحراء",
	     "غربي آسيا وشمال أفريقيا",
	     "شرق آسيا وجنوب شرق آسيا**",
	     "أمريكا اللاتينية ومنطقة البحر الكاريبي",
	     "أمريكا الشمالية ***",
	     "",
	     "العالم",
   ],
   crosshair: true
},
yAxis: {
max: 20,
min: 0,
tickInterval: 5,
format: '{value.million} KK',
title: {
    text: ''
}
},
tooltip: {
headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
		     '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
	     footerFormat: '</table>',
	       shared: true,
	       useHTML: true,
	       valuePrefix: 'KK',
},
plotOptions: {
column: {
       pointPadding: 0.2,
       borderWidth: 0
}
},
series: [
{
	       name: '',
	       dataLabels: {
			     enabled: true,
		     style: {
			     fontWeight: 'normal',
			     textOutline: false,
			     color: '#999999',
			     fontSize: '10px'
				      },
		     },
data: [
13.7,
8.3,
5.7,
4.9,
4.2,
1.4,
0.3,
null,
6.8,
]
},
]
}
